import React, { Suspense, useEffect, useRef } from 'react'
import './css/App.css'
import { AuthContextProvider } from './context/AuthContext'
import ThemeProvider from './theme'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import ScrollToTop from './components/ScrollToTop'
import Routes from './routes/Routes'
import { IconButton, styled } from '@mui/material'
import { closeSnackbar, SnackbarProvider } from 'notistack'
import Loader from './components/Loader'
import { AdminAuthContextProvider } from './context/AdminAuthContext'
import { FilterContextProvider } from './context/FilterContext'
import { ChatCountContextProvider } from './context/ChatCountContext'
import { requestPermission } from './firebase/firebase'
import CloseIcon from '@mui/icons-material/Close'
import { NODE_ENV } from './common/constants'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { IsGoogleRecaptchaEnabled } from './common/constants'

// alert notification
const StyledSnackbarProvider = styled(SnackbarProvider)`
  &.notistack-MuiContent-success {
    background-color: #ddab2e;
    color: #ffffff;
  }
  ,
  &.notistack-MuiContent-error {
    background-color: #ff1e1e;
  }
  ,
  &.notistack-MuiContent {
    box-shadow:
      0px 3px 2px -2px rgba(0, 0, 0, 0.06),
      0px 5px 3px -2px rgba(0, 0, 0, 0.02);
    font-weight: 500;
    border-radius: 12px;
  }
`

const App = () => {
  const btnRef = useRef(null)

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent)
  //     const isAndroid = /Android/i.test(navigator.userAgent)

  //     if (isIOS || /apple/i.test(navigator.vendor)) {
  //       requestPermission()
  //     } else if (
  //       isAndroid ||
  //       (!isIOS && localStorage.getItem('token') && btnRef.current)
  //     ) {
  //       btnRef.current.click()
  //     }
  //   }, 1000) // Wait for 1 second before auto-clicking the button

  //   return () => clearTimeout(timer)
  // }, [localStorage.getItem('token'), btnRef])

  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

    const timer = setTimeout(() => {
      if (
        /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
        /apple/i.test(navigator.vendor)
      ) {
        requestPermission()
      } else if (
        !/iPhone|iPad|iPod/i.test(navigator.userAgent) &&
        localStorage.getItem('token') &&
        btnRef.current
      ) {
        btnRef.current.click()
      }
    }, 1000)

    // Protect against developer tools (production only)
    let cleanupDevToolsProtection
    if (process.env.NODE_ENV === NODE_ENV.PRODUCTION) {
      const protectAgainstDevTools = () => {
        if (isMobile) return

        const devToolsOpen = () => {
          const widthThreshold = window.outerWidth - window.innerWidth > 160
          const heightThreshold = window.outerHeight - window.innerHeight > 160
          return widthThreshold || heightThreshold
        }

        const handleDevToolsOpen = () => {
          alert('Developer tools are not allowed on this site.')
          window.location.href = 'about:blank'
        }

        const intervalId = setInterval(() => {
          if (devToolsOpen()) {
            handleDevToolsOpen()
          }
        }, 1000)

        // Disable right-click and certain shortcuts
        const disableContextMenu = (e) => e.preventDefault()
        const disableShortcuts = (e) => {
          if (
            (e.ctrlKey && e.shiftKey && e.keyCode === 73) || // Ctrl+Shift+I
            (e.metaKey && e.altKey && e.keyCode === 73) || // Cmd+Option+I
            e.keyCode === 123 // F12
          ) {
            e.preventDefault()
          }
        }

        document.addEventListener('contextmenu', disableContextMenu)
        document.addEventListener('keydown', disableShortcuts)

        // Cleanup
        return () => {
          clearInterval(intervalId)
          document.removeEventListener('contextmenu', disableContextMenu)
          document.removeEventListener('keydown', disableShortcuts)
        }
      }

      cleanupDevToolsProtection = protectAgainstDevTools()
    }

    return () => {
      clearTimeout(timer)
      if (cleanupDevToolsProtection) cleanupDevToolsProtection()
    }
  }, [btnRef])

  return (
    <>
      <AuthContextProvider>
        <AdminAuthContextProvider>
          <FilterContextProvider>
            <ChatCountContextProvider>
              <BrowserRouter>
                <HelmetProvider>
                  <ThemeProvider>
                    <ScrollToTop />
                    <StyledSnackbarProvider
                      hideIconVariant
                      autoHideDuration={15000}
                      maxSnack={3}
                      preventDuplicate
                      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                      action={(snackbarId) => (
                        <IconButton
                          size="small"
                          color="inherit"
                          disableRipple
                          sx={{
                            backgroundColor: 'transparent',
                            '&:hover': { backgroundColor: 'transparent' },
                            padding: 0,
                          }}
                          onClick={() => closeSnackbar(snackbarId)}
                        >
                          <CloseIcon fontSize="small" sx={{ color: '#fff' }} />
                        </IconButton>
                      )}
                    >
                      {IsGoogleRecaptchaEnabled ? (
                        <GoogleReCaptchaProvider
                          reCaptchaKey={
                            process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY
                          }
                        >
                          <Suspense fallback={<Loader />}>
                            <Routes />
                          </Suspense>
                        </GoogleReCaptchaProvider>
                      ) : (
                        <Suspense fallback={<Loader />}>
                          <Routes />
                        </Suspense>
                      )}
                    </StyledSnackbarProvider>
                  </ThemeProvider>
                </HelmetProvider>
              </BrowserRouter>
            </ChatCountContextProvider>
          </FilterContextProvider>
        </AdminAuthContextProvider>
      </AuthContextProvider>
      <button
        onClick={() => {
          requestPermission()
        }}
        ref={btnRef}
        style={{ position: 'fixed', visibility: 'hidden' }}
      >
        Enable Notification
      </button>
    </>
  )
}

export default App
